export default function getMaskedMoveAnimation(element, settings, animationcalculation){
    const animation = {
        y: 0,
        x: 0
    };

    //Set the position properties based on the startposition
    if( settings.start_position ){
        const ownFontSize = element.data('fontsize') ?? 1
        // set y position
        if( settings.start_position.indexOf("top") > -1 ){
            animation.y =  `-=${(element.outerHeight() / animationcalculation.scale * animationcalculation.pxemratio) / ownFontSize}em`;
        }else if( settings.start_position.indexOf("bottom") > -1 ){
            animation.y = `+=${(element.outerHeight() / animationcalculation.scale * animationcalculation.pxemratio) / ownFontSize}em`;
        }
        // set x position
        if( settings.start_position.indexOf("left") > -1 ){
            animation.x = `-=${(element.outerWidth() / animationcalculation.scale * animationcalculation.pxemratio) / ownFontSize}em`;
        }else if( settings.start_position.indexOf("right") > -1 ){
            animation.x = `+=${(element.outerWidth() / animationcalculation.scale * animationcalculation.pxemratio) / ownFontSize}em`;
        }
    }
    return animation;
}
